// CookieConsentLanding.tsx - Updated with Language Support and Responsive Dropdown
//
import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import { useConsent } from '../../../../Context/ConsentContext';
import '../../../../Assets/styles/LandingStyles/CookieBanner/CookieBannerLanding.css';
import { useLanguage } from '../../../../Core/Translations/LanguageContext'; // Adjust import path
import { LanguageSelector } from 'Core/Translations/LanguageSelector'; // Adjust import path

const CookieConsentLanding: React.FC = () => {
    const {
        showBanner,
        confirmConsent,
        toggleCustomizeSettings
    } = useConsent();

    const { t } = useLanguage(); // Use the language hook

    // State to hold the current window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        // Function to update state when the window is resized
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup function to remove the event listener
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty dependency array ensures this runs only once on mount

    // Determine the dropdown direction based on window width
    // You can adjust the 768px breakpoint as needed
    const dropdownDirection = windowWidth <= 768 ? 'down' : 'up';

    if (!showBanner) return null;

    return (
        <>
            <div className="cookie-landing-overlay" />
            <div className="cookie-landing-consent">
                <div className="cookie-landing-container">
                    <div 
                        className="cookie-landing-header" 
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                        <h2 className="cookie-landing-title">{t.cookieConsent.landing.title}</h2>
                        {/* 👇 Pass the dynamic dropdownDirection prop here */}
                        <LanguageSelector theme="light" dropdownDirection={dropdownDirection} />
                    </div>
                    <p className="cookie-landing-description">
                        {t.cookieConsent.landing.description}
                    </p>

                    <div className="cookie-landing-btn-group">
                        <button
                            className="cookie-landing-btn cookie-landing-btn-accept-all"
                            onClick={confirmConsent}
                            data-testid="accept-all-cookies-button"
                        >
                            {t.cookieConsent.landing.acceptAll}
                        </button>
                        <button
                            className="cookie-landing-btn cookie-landing-btn-customize-settings"
                            onClick={toggleCustomizeSettings}
                            data-testid="customize-settings-button"
                        >
                            {t.cookieConsent.landing.customizeSettings}
                        </button>
                    </div>

                    <p 
                        className="cookie-landing-fineprint"
                        // Use dangerouslySetInnerHTML for the <br /> tag in the translation
                        dangerouslySetInnerHTML={{ __html: t.cookieConsent.landing.fineprint }}
                    />
                </div>
            </div>
        </>
    );
};

export default CookieConsentLanding;